import type { RumInitConfiguration } from '@datadog/browser-rum';
import { datadogRum } from '@datadog/browser-rum';

interface InitDatadogRumProps extends Omit<
  RumInitConfiguration,
  'applicationId' | 'clientToken'
> {
  applicationId?: string | null;
  clientToken?: string | null;
  service: string;
}

let initialized = false;

export const initDatadogRum = ({
  applicationId,
  clientToken,
  env,
  service,
  version,
  ...remainingConfig
}: InitDatadogRumProps) => {
  if (initialized) return;

  // These env vars are only provided on production, so we don't init on dev env
  if (!applicationId || !clientToken || !service) return;

  datadogRum.init({
    applicationId,
    clientToken,
    defaultPrivacyLevel: 'mask-user-input',
    env,
    service,
    sessionReplaySampleRate: 5,
    sessionSampleRate: 100,
    site: 'datadoghq.com',
    traceContextInjection: 'sampled',
    traceSampleRate: 10,
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    version,
    ...remainingConfig,
  });
  datadogRum.startSessionReplayRecording();
  initialized = true;
};

export const registerJdid = (jdid: string) => {
  if (jdid) {
    datadogRum.setGlobalContextProperty('janeDeviceId', jdid);
  }
};
